// Per-channel Company ID allowlists for the adviser channel pages
// (/pf, /ifa, /mfc). Mirrors Advisers::EnrolmentCompanies in the Rails
// backend, where IDs (not trading names) are the source of truth:
// 31 = PFA, 23 = DFA, 32 = AFD, 39 = IFA, 27 = MFC Broker,
// 42 = MFC Franchise, 4 = Wealth, 41 = Broker.
// ID 14 is the non-production MFC test company (never returned by the
// backend in production), included so staging testers can use /mfc.

export const PFA_CHANNEL_COMPANY_IDS = [31, 23, 32]; // PFA, DFA, AFD
export const IFA_CHANNEL_COMPANY_IDS = [39]; // IFA
export const MFC_CHANNEL_COMPANY_IDS = [27, 42, 14]; // MFC Broker, MFC Franchise, MFC test
